var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatioNavigationCtrl = function () {
    function PaginatioNavigationCtrl() {
        _classCallCheck(this, PaginatioNavigationCtrl);

        this.pageNum = 0;
        this.totalPages = 0;
        this.showElement = false;
    }

    _createClass(PaginatioNavigationCtrl, [{
        key: 'hasNext',
        value: function hasNext() {
            return this.pageNum < this.totalPages - 1;
        }
    }, {
        key: 'hasPrevious',
        value: function hasPrevious() {
            return this.pageNum > 0;
        }
    }, {
        key: 'previous',
        value: function previous() {
            this.pageNum -= 1;
            this.load();
        }
    }, {
        key: 'next',
        value: function next() {
            this.pageNum += 1;
            this.load();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var reset = _ref.reset,
                sharedPageNum = _ref.sharedPageNum,
                externalDisplayPagination = _ref.externalDisplayPagination;

            if (reset && reset.currentValue !== reset.previousValue) {
                this.pageNum = 0;
                this.totalPages = 0;
                this.load();
            }

            if (sharedPageNum != null && sharedPageNum.currentValue != null && sharedPageNum.currentValue !== sharedPageNum.previousValue && sharedPageNum.currentValue !== this.pageNum) {

                this.pageNum = sharedPageNum.currentValue;
                this.load();
            }

            if (externalDisplayPagination && typeof externalDisplayPagination.previousValue === 'boolean' && externalDisplayPagination.currentValue !== externalDisplayPagination.previousValue) {

                this.showElement = externalDisplayPagination.currentValue;
            }
        }
    }, {
        key: 'load',
        value: function load() {
            var _this = this;

            var currentPage = this.pageNum;
            var indexStart = currentPage * this.pageSize;

            // pagination is one based
            var startPos = indexStart + 1;
            var endPos = indexStart + this.pageSize;

            return this.loadByOffset({ offsetStart: startPos - 1, offsetEnd: endPos - 1 }).then(function (paginatedData) {
                _this.startPos = startPos;
                _this.endPos = indexStart + paginatedData.items.length;
                _this.totalPages = Math.ceil(paginatedData.maxNumberOfResults / _this.pageSize);
                _this.totalItems = paginatedData.maxNumberOfResults;
                _this.onPaginationNavigation({ paginatedData: paginatedData, pageNum: _this.pageNum, totalPages: _this.totalPages });

                if (_this.externalDisplayPagination === undefined) {
                    _this.showElement = _this.totalPages > 1;
                } else {
                    _this.showElement = _this.externalDisplayPagination;
                }
            });
        }
    }]);

    return PaginatioNavigationCtrl;
}();

export default PaginatioNavigationCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/pagination/PaginationNavigation/PaginationNavigationCtrl.js
// module id = 1921
// module chunks = 0